var AWSDataPortsServiceServiceModule = /** @class */ (function () {
    function AWSDataPortsServiceServiceModule() {
    }
    return AWSDataPortsServiceServiceModule;
}());
export { AWSDataPortsServiceServiceModule };
